export const tl_data = [
    {
        "title": {
            "en": "Coconut Oil",
            "fr": "Huile de coco",
        },
        "description": {
            "en": "Gives it the juicy, melt-in-your-mouth goodness",
            "fr": "Pour rendre la boulette tendre et juteuse"
        },
        "image": {
            "en": "ingredients-coconut.png",
            "fr": "ingredients-coconut.png"
        }
    },
    {
        "title": {
            "en": "Yellow Peas",
            "fr": "Pois jaunes"
        },
        "description": {
            "en": "Provides most of its delicious protein",
            "fr": "La principale source de délicieuses protéines"
        },
        "image": {
            "en": "ingredients-yellow-peas.png",
            "fr": "ingredients-yellow-peas.png"
        }
    },
    {
        "title": {
            "en": "Pomegranates",
            "fr": "Grenades"
        },
        "description": {
            "en": "Source of antioxidants and vitamins",
            "fr": "Une source d’antioxydants et de vitamines"
        },
        "image": {
            "en": "ingredients-pomegranate.png",
            "fr": "ingredients-pomegranate.png"
        }
    },
    {
        "title": {
            "en": "Mung Beans",
            "fr": "Haricots mungo"
        },
        "description": {
            "en": "Gives it texture",
            "fr": "Pour lui donner de la texture"
        },
        "image": {
            "en": "ingredients-mung-beans.png",
            "fr": "ingredients-mung-beans.png"
        }
    },
    {
        "title": {
            "en": "Rice",
            "fr": "Riz"
        },
        "description": {
            "en": "Another source of protein",
            "fr": "Une autre source de protéines"
        },
        "image": {
            "en": "ingredients-rice.png",
            "fr": "ingredients-rice.png"
        }
    },
    {
        "title": {
            "en": "Potatoes",
            "fr": "Pommes de terre"
        },
        "description": {
            "en": "Helps keep it all together",
            "fr": "Pour aider à tout faire tenir ensemble"
        },
        "image": {
            "en": "ingredients-potatoes.png",
            "fr": "ingredients-potatoes.png"
        }
    },
    {
        "title": {
            "en": "Apples",
            "fr": "Pommes"
        },
        "description": {
            "en": "Another source of antioxidants",
            "fr": "Une autre source d’antioxydants"
        },
        "image": {
            "en": "ingredients-apples.png",
            "fr": "ingredients-apples.png"
        }
    },
    {
        "title": {
            "en": "Beets",
            "fr": "Betteraves"
        },
        "description": {
            "en": "Adds colour and vitamins",
            "fr": "Pour ajouter de la couleur et des vitamines"
        },
        "image": {
            "en": "ingredients-beets.png",
            "fr": "ingredients-beets.png"
        }
    }
        
    
]